"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const MatchRoad_1 = __importDefault(require("@Components/MatchComponents/MatchRoad"));
const Button_1 = require("@Components/Buttons/Button");
const react_1 = __importDefault(require("react"));
const Popup_1 = __importDefault(require("@App/kit/components/Popups/Popup"));
const pluralize_1 = __importDefault(require("pluralize"));
const MatchWorksPopup = (props) => {
    const { recordingGroupsCount, onCancel, onContinue } = props;
    return (react_1.default.createElement(Popup_1.default, { onClose: onCancel },
        react_1.default.createElement("div", { className: "modal-content" },
            react_1.default.createElement("h2", null, "Let's continue matching recordings."),
            react_1.default.createElement("p", null, "To complete this process, you'll move through two steps:"),
            react_1.default.createElement(MatchRoad_1.default, { step: 0 }),
            react_1.default.createElement("h5", null,
                "In the next step, you'll locate the work in your catalog that you'd like to match with the",
                ' ',
                (0, pluralize_1.default)('selected recording group', recordingGroupsCount, true),
                "."),
            react_1.default.createElement("div", { className: "button-row" },
                react_1.default.createElement(Button_1.Button, { mainColor: true, type: "secondary", onClick: onCancel }, "Cancel"),
                react_1.default.createElement(Button_1.Button, { mainColor: true, type: "primary", onClick: onContinue }, "Continue")))));
};
exports.default = MatchWorksPopup;
